import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

export class PortalContainer extends React.Component {
  constructor (props) {
    super(props)
    this.containerEl = document.getElementById(props.parentContainer)
  }

  render () {
    return ReactDOM.createPortal(this.props.children, this.containerEl)
  }
}

PortalContainer.propTypes = {
  children: PropTypes.node.isRequired,
  parentContainer: PropTypes.string.isRequired
}
